import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Phone, Mail, MapPin, Instagram } from 'lucide-react';
export function ContactPage() {
  return <main className="min-h-screen pt-32 pb-20 px-6" data-id="element-215">
      <div className="max-w-2xl mx-auto" data-id="element-216">
        {/* Hero Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-16 text-center" data-id="element-217">
          <h1 className="text-5xl md:text-7xl font-heading text-white inline-block relative" data-id="element-218">
            LET'S WORK
            <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1/2 h-1 bg-accent-blue" data-id="element-219"></div>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="space-y-8 flex flex-col" data-id="element-220">
          {/* WhatsApp CTA */}
          <a href="https://wa.me/48536052998" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 w-full bg-[#25D366] text-white font-heading tracking-wider text-2xl py-6 rounded-2xl hover:bg-[#20bd5a] transition-colors shadow-lg shadow-[#25D366]/20" data-id="element-221">
            <MessageCircle className="w-8 h-8" data-id="element-222" />
            CLICK TO WHATSAPP
          </a>

          {/* Contact Details */}
          <div className="bg-dark-elevated border border-dark-border rounded-2xl p-8 space-y-6" data-id="element-223">
            <div className="flex items-center gap-4 text-gray-300" data-id="element-224">
              <div className="w-12 h-12 rounded-full bg-dark-primary flex items-center justify-center border border-dark-border" data-id="element-225">
                <Phone className="w-5 h-5 text-accent-blue" data-id="element-226" />
              </div>
              <div data-id="element-227">
                <p className="text-sm text-gray-500 font-body" data-id="element-228">
                  Phone / WhatsApp
                </p>
                <p className="font-heading text-xl tracking-wide" data-id="element-229">
                  +48 536 052 998
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 text-gray-300" data-id="element-230">
              <div className="w-12 h-12 rounded-full bg-dark-primary flex items-center justify-center border border-dark-border" data-id="element-231">
                <Mail className="w-5 h-5 text-accent-blue" data-id="element-232" />
              </div>
              <div data-id="element-233">
                <p className="text-sm text-gray-500 font-body" data-id="element-234">Email</p>
                <p className="font-heading text-xl tracking-wide" data-id="element-235">
                  CONTACT@SZULCALEKS.COM
                </p>
              </div>
            </div>

            <a href="https://www.instagram.com/aleks.szulc1/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 text-gray-300 hover:text-white transition-colors" data-id="element-236">
              <div className="w-12 h-12 rounded-full bg-dark-primary flex items-center justify-center border border-dark-border" data-id="element-237">
                <Instagram className="w-5 h-5 text-accent-blue" data-id="element-238" />
              </div>
              <div data-id="element-239">
                <p className="text-sm text-gray-500 font-body" data-id="element-240">Instagram</p>
                <p className="font-heading text-xl tracking-wide" data-id="element-241">
                  @ALEKS.SZULC1
                </p>
              </div>
            </a>

            <div className="flex items-center gap-4 text-gray-300" data-id="element-242">
              <div className="w-12 h-12 rounded-full bg-dark-primary flex items-center justify-center border border-dark-border" data-id="element-243">
                <MapPin className="w-5 h-5 text-accent-blue" data-id="element-244" />
              </div>
              <div data-id="element-245">
                <p className="text-sm text-gray-500 font-body" data-id="element-246">Location</p>
                <p className="font-heading text-xl tracking-wide" data-id="element-247">
                  UL. KOŃSKI JAR 6, WARSZAWA
                </p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="min-h-[250px] rounded-2xl overflow-hidden" data-id="element-248">
            <img src="https://cdn.magicpatterns.com/uploads/edwNNLnDKrMNdBaM9tfypV/image.png" alt="Google Map - ul. Koński Jar 6, 02-785 Warszawa" className="w-full h-full object-cover rounded-2xl" data-id="element-249" />
          </div>
        </motion.div>
      </div>
    </main>;
}